import { render, staticRenderFns } from "./MyProjectsContractList.vue?vue&type=template&id=7dd030eb"
import script from "./MyProjectsContractList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsContractList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports